import { loadView } from '@/router/routerHelpers';

const toolsRoutes = [
  {
    path: '/tools',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: 'custom_objects',
    },
    children: [
      {
        path: '',
        name: 'tools',
        meta: { feature: 'custom_objects' },
        component: loadView('tools/Tools'),
      },
    ],
  },
];

export default toolsRoutes;
